import React from 'react';
import styled from 'styled-components';
import { H1, P as DP } from '@futurefamily/ef-components';
import TreatmentForm from '../TreatmentForm';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1 1 100%;
  min-height: 100%;
`;

const Header = styled.div`
  padding-top: var(--page-top-offset);
`;


const Body = styled.div`
  display: flex;
  flex: 1 1 100%;
  background-color: var(--teal);
  min-width: 100%;
`;

const P = styled(DP)`
  font-size: var(--font-size-3);
`;


export function TreatmentOptions () {
  return (
    <Wrapper>
      <Header className="container mb-2">
        <div className="row text-center">
          <H1>Donor Egg Plan Estimate Calculator</H1>
        </div>

        <div className="row justify-content-center mt-4">
          <div className="col">
            <P className="mb-5 text-center">To better understand the costs of purchasing Fairfax EggBank frozen donor eggs, and your payment options, please select one of the options below.</P>
          </div>
        </div>
      </Header>

      <Body className="justify-content-center">
        <TreatmentForm />
      </Body>
    </Wrapper>
  );
}

export default TreatmentOptions;
